const motionDurationShort = '0.25s';

export { motionDurationShort };
